import UAParser from "ua-parser-js";

export type DeviceLabel = "mobile" | "tablet" | "laptop" | "desktop";

// Best-effort client-side detection for a coarse device label.
// Prefers UAParser data, falls back to UA-CH and simple heuristics.
export const getDeviceLabel = (): DeviceLabel => {
  if (typeof window === "undefined") return "desktop";

  const parser = new UAParser();
  const res = parser.getResult();

  const ua = (navigator.userAgent || "").toLowerCase();
  const uaData = (navigator as any).userAgentData;
  const platform = (uaData?.platform || "").toLowerCase();
  const deviceType = (res.device?.type || "").toLowerCase();
  const vendor = (res.device?.vendor || "").toLowerCase();
  const model = (res.device?.model || "").toLowerCase();
  const osName = (res.os?.name || "").toLowerCase();

  // Quick wins
  if (deviceType === "mobile" || uaData?.mobile || /mobi|iphone|android/.test(ua)) return "mobile";
  if (deviceType === "tablet") return "tablet";

  // Apple Macintosh typically implies laptop (MacBook); desktops (iMac/Mac Pro) are not reliably exposed
  if (vendor === "apple" && model === "macintosh") return "laptop";

  // Touch heuristic for tablets when type is unknown
  const touchPoints = (navigator as any).maxTouchPoints || 0;
  const width = typeof screen !== "undefined" ? screen.width : 0;
  if (touchPoints > 1 && width >= 768 && width <= 1366) return "tablet";

  // Desktop OS default → label as laptop for portability semantics
  if (/(mac os|windows|linux|chrome os)/.test(osName) || /mac|win|linux/.test(platform))
    return "laptop";

  return "desktop";
};
